// Retain authored data, editors and renderers while withholding these empty
// event-detail sections from both the inspector and customer canvas.
export const LANDING_BLOCKS_HIDDEN: ReadonlySet<string> = new Set(["speakers", "included", "faq"]);

export function moveVisibleLandingBlock(order: string[], id: string, dir: number): string[] | null {
  const visible = order.filter((blockId) => !LANDING_BLOCKS_HIDDEN.has(blockId));
  const visibleIndex = visible.indexOf(id);
  const targetId = visible[visibleIndex + dir];
  if (visibleIndex < 0 || !targetId) return null;

  const next = order.slice();
  const from = next.indexOf(id);
  const to = next.indexOf(targetId);
  next[from] = targetId;
  next[to] = id;
  return next;
}
